// import Vue from 'vue';
import axios from 'axios';
// import { Loading, Message } from 'element-ui';
import router from '../router/index.js';
import {Toast} from 'vant'
// import { delete } from 'vue/types/umd';

// let loading;


// 显示加载中遮罩层
// function startLoading() {
//     loading = Loading.service({
//         lock: true,
//         text: '加载中',
//         background: 'rgba(0, 0, 0, 0.7)'
//     });
// };

// 关闭加载中遮罩层
function endLoading() {
  if (loading) loading.close();
};

// 请求拦截
axios.interceptors.request.use(
  (confing) => {
    let token = localStorage.getItem('token') || ''
    // var isHideStartLoading = localStorage.getItem('isHideStartLoading');
    // if (isHideStartLoading == "Y") {
    // localStorage.removeItem('isHideStartLoading')
    // } else {
    // startLoading();
    // }
    // startLoading();
    //设置请求头
    // if (localStorage.eToken) {
    //     confing.headers.Authorization = localStorage.eToken;
    // }
    if (token) {
      confing.headers.Authorization = token;
    }
    confing.headers.clientType = 'store';
    return confing;
  },
  (error) => {
    // endLoading();
    return Promise.reject(error);
  }
)

//响应拦截
axios.interceptors.response.use(
  (response) => {
    // endLoading();
    if (response.data.code == 401) {
      Toast(response.data.msg);
      //清楚token
      localStorage.removeItem('token');
      //跳转到登录页面
      mui.plusReady(function () {
        plus.navigator.setStatusBarBackground('#4A69FF');
      })
      router.push('/login');
      return;
    }
    return response;
  },
  (error) => {
    // endLoading();
    // debugger
    // router.push('/fail')
    return Promise.reject(error);
  }
)
export default axios;



// WEBPACK FOOTER //
// ./src/request/request.js